// Vue 2 版本的 WebSocket 状态管理
import Vue from 'vue'

const state = Vue.observable({
  ws: null,
  connected: false,
  listeners: new Map()
})

export const websocketStore = {
  get ws() {
    return state.ws
  },
  get connected() {
    return state.connected
  },
  connect(url = 'ws://localhost:8080/ws') {
    if (state.ws && state.ws.readyState === WebSocket.OPEN) return
    try {
      state.ws = new WebSocket(url)
      state.ws.onopen = () => {
        state.connected = true
      }
      state.ws.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data)
          this.handleMessage(msg)
        } catch (e) {
          console.error('WebSocket message parse failed', e)
        }
      }
      state.ws.onclose = () => {
        state.connected = false
        setTimeout(() => {
          if (!state.connected) this.connect(url)
        }, 3000)
      }
      state.ws.onerror = () => {
        state.connected = false
      }
    } catch (e) {
      state.connected = false
    }
  },
  disconnect() {
    if (state.ws) state.ws.close()
    state.ws = null
    state.connected = false
  },
  on(event, cb) {
    if (!state.listeners.has(event)) state.listeners.set(event, [])
    state.listeners.get(event).push(cb)
  },
  handleMessage(data) {
    const { type, payload } = data || {}
    if (!type) return
    const cbs = state.listeners.get(type) || []
    cbs.forEach((cb) => {
      try {
        cb(payload)
      } catch (e) {
        console.error('listener failed', e)
      }
    })
  }
}





